import { useEffect, useRef } from "react";
import { usePartnerNavigate } from "src/api/hooks/usePartnerNavigate";
import { useCourtAuth } from "src/components/court-auth";
import { useMemberInfoState } from "src/recoil/member/hook";

/**
 * 로그인 화면
 */
const Login = () => {
  const navigate = usePartnerNavigate();
  const { login } = useMemberInfoState();
  const { security } = useCourtAuth();

  // 인가 요청은 화면당 1회만 수행한다.
  // navigate/login 은 렌더마다 새 참조라 effect 가 반복 실행되는데,
  // 인가 요청이 반복되면 PKCE code_verifier 가 매번 새로 저장되어
  // 먼저 시작된 리다이렉트의 code_challenge 와 어긋나 토큰 교환이 실패할 수 있다.
  const requestedRef = useRef(false);

  useEffect(() => {
    // if (security.status === "authenticated") {
    //   // 로그인 되어있으면 신청/계약 목록 화면으로 이동
    //   // navigate(route.mainPath);
    // } else {
    //   login();
    // }

    if (requestedRef.current) return;
    requestedRef.current = true;

    login();
  }, [security, navigate, login]);

  return (
    <>
      {/* <MetaTag title="로그인 | TaapSpace" imgsrc={`${process.env.REACT_APP_S3_CONTENT_BASEURL}court/taapspace_logo_og.png`} />
      <Header rightDisabled={true} />
      <div className="my-page">
        <article className="before-login-contents">
          <h1>로그인</h1>
          <p>
            플레이하실 준비가 되셨나요?
            <br />
            로그인이 필요한 페이지입니다.
            <br />
            비회원도 '시작하기'로 회원가입 후 이용 가능합니다.
          </p>
          <BaseButton className="login-btn" title="시작하기" onClick={() => login()} />
        </article>
      </div> */}
    </>
  );
};
export default Login;
